import React, { Component } from 'react'
import { Motion, spring, presets } from 'react-motion'
import PropTypes from 'prop-types'

export default class Carousel extends Component {
  constructor (props) {
    super(props)
    var newSlides = this.props.slides
    newSlides.unshift(this.props.slides[this.props.slides.length - 1])
    newSlides.push(this.props.slides[1])
    newSlides.push(this.props.slides[2])
    this.state = {
      index: 0,
      slides: newSlides,
      paused: false
    }
    this.INTERVAL = 3000
    this.slideWidth = 86
    this.borderWidth = (100 - this.slideWidth) / 2
    this.instant = true
  }

  tick () {
    if (this.state.index === this.state.slides.length - 3) {
      this.setState({index: 0}, () => {
        this.tick()
      })
    } else {
      this.setState({index: this.state.index + 1})
    }
  }

  selectLanguageAndOpenPl (key) {
    this.props.selectLanguage(key)
    // this.props.togglePl(true)
  }

  // deprecated
  // pause () {
  //   this.setState({paused: true}, () => {
  //     clearInterval(this.interval)
  //   })
  // }

  // deprecated
  // unpause () {
  //   this.setState({paused: false}, () => {
  //     this.interval = setInterval(this.tick.bind(this), this.props.interval || this.INTERVAL)
  //   })
  // }

  componentDidMount () {
    this.interval = setInterval(this.tick.bind(this), this.props.interval || this.INTERVAL)
  }

  componentWillUpdate (nextProps, nextState) {
    if ((this.state.index === 0 && nextState.index === this.state.slides.length - 3) ||
      (this.state.index === this.state.slides.length - 3 && nextState.index === 0)) {
      this.instant = true
    } else {
      this.instant = false
    }
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  render () {
    let xTranslateLeft = -(this.state.index + 1) * this.slideWidth + this.borderWidth
    let xTranslateRight = (this.state.index - (this.state.slides.length - 2)) * this.slideWidth + this.borderWidth
    let xTranslate = this.props.slideRTL ? xTranslateLeft : xTranslateRight

    return <div>
             <Motion style={{x: this.instant ? xTranslate : spring(xTranslate, presets.gently)}}>
               {({x}) => <div className={this.props.className} style={{width: (this.state.slides.length * this.slideWidth + 'vw'), transform: `translate(${x}vw, 0)`}}>
                            {this.state.slides.map((text, i) => {
                               let key = Object.keys(text)[0]
                               return <div className={this.props.className + '-slide ' + this.props.className + '--' + key} key={key + i} style={{width: (this.slideWidth + 'vw')}}>
                                        <div className={this.props.className + '-slide-text'} dangerouslySetInnerHTML={{__html: text[key]}} />
                                        {/* <button className={this.props.className + '-slide-button ' + this.props.className + '-slide-button--' + key} onClick={this.selectLanguageAndOpenPl.bind(this, key)}>{(key === 'ar') ? 'اشترك' : ((key === 'en') ? 'join' : 'mitmachen')}</button> */}
                                      </div>
                             })}
                          </div>}
             </Motion>
           </div>
  }
}

Carousel.propTypes = {
  slides: PropTypes.array.isRequired,
  interval: PropTypes.number,
  className: PropTypes.string.isRequired,
  slideRTL: PropTypes.bool
}



/** WEBPACK FOOTER **
 ** ./src/components/carousel.js
 **/